import { render, staticRenderFns } from "./employee-info.vue?vue&type=template&id=71fb61c9&"
import script from "./employee-info.vue.ts?vue&type=script&lang=ts&"
export * from "./employee-info.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports